import { ProviderAvailability } from '@types';
import { GroupedAvailabilitiesByTimeBlock, TimeBlock } from '../context/utils';

export function getTimeSlotsCountByTimeBlock(
  groupedAvailabilitiesByTimeBlock: GroupedAvailabilitiesByTimeBlock,
  timeBlock: TimeBlock,
) {
  let timeSlotsCount = 0;

  if (timeBlock === 'now' || timeBlock === 'today') {
    const { now, today } = groupedAvailabilitiesByTimeBlock;

    timeSlotsCount =
      getTimeSlotsCountByAvailabilities(now) +
      getTimeSlotsCountByAvailabilities(today);
  } else {
    const availabilities = groupedAvailabilitiesByTimeBlock[timeBlock];

    timeSlotsCount = getTimeSlotsCountByAvailabilities(availabilities);
  }

  return timeSlotsCount;
}

function getTimeSlotsCountByAvailabilities(
  availabilities: ProviderAvailability[],
) {
  return availabilities.reduce((count, availability) => {
    const { timeSlotCollection } = availability;
    const timeSlotLength = timeSlotCollection.reduce(
      (acc, timeSlot) => acc + timeSlot.times.length,
      0,
    );

    return count + timeSlotLength;
  }, 0);
}
